/**
 *   * this create tour info dropdown effect
 *   **/
import $ from 'jquery';

export const tourInfoDropDown = () => {
	
	if ($('a.tourLegacy-toggle').length > 0) {	

		$("a.tourLegacy-toggle").on("click", function(e){
			
			e.preventDefault();
			
			var selItem = $(this);
			var dt = selItem.parent().parent().find(".desktopContent");

			if(selItem.hasClass('active')){
				selItem.parent().removeClass('active');
				selItem.removeClass('active');
				dt.removeClass("active");
			}else{
				selItem.parent().parent().parent().find('.tourLegacy-toggle').removeClass('active');
				selItem.parent().parent().parent().find('.tourLegacy.active').removeClass('active');
				selItem.parent().addClass('active');
				selItem.addClass('active');
				dt.addClass('active');
			}

		});
		
	}

}

